import setGiftCardsSuccess from 'redux/modules/order/reducer/set-gift-cards-success';

const reducer = (state: any, action: any) => {
  const { paymentInfo, totals } = action.result ?? {};
  const giftCardAction = {
    giftCards: paymentInfo?.giftCards,
    giftVouchers: paymentInfo?.giftVouchers,
    estimatedTotals: totals?.estimated,
  };
  const newState = setGiftCardsSuccess(state, giftCardAction);
  return {
    ...newState,
    waiting: false,
    loaded: true,
  };
};

export default reducer;
